module.exports = __webpack_public_path__ + "static/media/Picture9.4cd1e54f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Picture9.jpg
// module id = 1541
// module chunks = 0